import { Component, inject, signal, ViewChild } from '@angular/core';

import { HttpParams, httpResource } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Params, RouterModule, Router } from '@angular/router';
import { ListComponent } from '@components/list/list.component';
import { environment } from '@environment';
import { ItemListResponse, PlanktonOrigin } from '@models';
import {
  PlanktonOriginAbstractPipe,
  PlanktonOriginIconPipe,
  PlanktonOriginTitlePipe,
} from '@pipes';

@Component({
  selector: 'app-plankton-origin-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  imports: [
    ListComponent,
    MatButtonModule,
    MatChipsModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    PlanktonOriginAbstractPipe,
    PlanktonOriginIconPipe,
    PlanktonOriginTitlePipe,
    RouterModule,
  ],
})
export class PlanktonOriginListComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  route = inject(ActivatedRoute);
  router = inject(Router);

  planktonDatasetId = environment.planktonDatasetId;

  page = signal(0);
  pageSize = signal(10);
  q = signal('');

  httpParams(): HttpParams {
    return new HttpParams()
      .set('count', true)
      .set('skip', this.page() * this.pageSize())
      .set('take', this.pageSize());
  }

  response = httpResource<ItemListResponse<PlanktonOrigin>>(() => {
    return `${environment.kinkoHost}/plankton/origin/?${this.httpParams()}`;
  });

  constructor() {
    this.route.queryParams.subscribe((params: Params) => {
      this.page.set(parseInt(params['page']) || 0);
      this.pageSize.set(parseInt(params['pageSize']) || 10);
    });
  }

  onPageEvent(event: PageEvent) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
      queryParams: {
        page: event.pageIndex || undefined,
        pageSize: event.pageSize === 10 ? undefined : event.pageSize,
      },
      replaceUrl: true,
    });
  }
}
